import React, { useEffect } from 'react';
import { HotkeyBadge } from 'pages/Tagging/components/HotkeyBadge/HotkeyBadge';
import { useInjection } from 'services/ioc/ioc.react';
import { HotkeyService } from 'services/helper-services/HotkeyService';
import { ServiceTypes } from 'constants/ServiceTypes';
import { BaseState } from 'models/baseRunners/BaseState';
import { Hotkeys } from 'constants/Hotkeys';
import { CancelActionText, RemovePlayerItem, RemovePlayerWrapper } from './RemovePlayerStyles';

interface IProps {
  lastDroppedItem: BaseState;
  onPressHotkeyCallback: (removedPlayer: BaseState) => void;
}

const UndoRemovePlayer: React.FC<IProps> = (props) => {
  const { lastDroppedItem, onPressHotkeyCallback } = props;

  const hotkeyService = useInjection<HotkeyService>(ServiceTypes.HotkeyService);

  const onPressHotkey = (event: KeyboardEvent): boolean => {
    if (onPressHotkeyCallback) {
      onPressHotkeyCallback(lastDroppedItem);
    }
    return false;
  };

  useEffect(() => {
    hotkeyService.subscribe(Hotkeys.BaseRunners.UndoRemovePlayer.keyCode, onPressHotkey, 'Remove Player');

    return () => {
      hotkeyService.unsubscribe('Remove Player');
    };
  }, [onPressHotkeyCallback]);

  return (
    <RemovePlayerWrapper>
      <RemovePlayerItem>
        <CancelActionText>Cancel the action?</CancelActionText>
        <HotkeyBadge hotkey={Hotkeys.BaseRunners.UndoRemovePlayer.hotkeyDisplay} />
      </RemovePlayerItem>
    </RemovePlayerWrapper>
  );
};

export default UndoRemovePlayer;
